import React from "react";
import style from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { PAGE } from "./redux/actions";
import { Menu, pages, Header, Footer } from "./components";
import CONSTANTS from "./constants";

const App = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector((store) => store[PAGE]);
  return (
    <Wrapper>
      <Header />
      <Menu onChange={onChangePage(dispatch)} selection={currentPage} />
      {getPage(currentPage, pages)}
      <Footer />
    </Wrapper>
  );
};
export const getPage = (currentPage, pages) => {
  const { Background, Projects, Contact } = pages;
  return {
    [CONSTANTS.BACKGROUND]: <Background />,
    [CONSTANTS.PROJECTS]: <Projects />,
    [CONSTANTS.CONTACT]: <Contact />,
  }[currentPage];
};
export const onChangePage = (dispatch) => {
  return (payload) => {
    dispatch({ type: PAGE, payload });
  };
};
const Wrapper = style.div`
  background: white;
  width:100%;
  height:100%;
  position:relative;
  padding: 10em 0;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    padding: 15em 0;
  }
`;
export default App;
